<template>
  <el-table
    :data="dataSource"
    border
    :row-style="showTr"
    height="100%"
    style="width: 100%">
    <el-table-column
      :width="column.text === '团队名称' ? '240px' : ''"
      :align="column.text !== '团队名称' ? 'center' : 'left'"
      v-for="(column, index) in columns"
      :key="column.dataIndex"
      :label="column.text">
      <template slot-scope="scope">
        <span
          v-show="spaceIconShow(index)"
          v-for="(space, levelIndex) in scope.row.priLevel"
          class="ms-tree-space"
          :key="`space${levelIndex}`">
        </span>
        <i
          v-if="toggleIconShow(index, scope.row)"
          @click="toggle(scope.$index)"
          :class="scope.row.priExpanded ? 'el-icon-caret-bottom' : 'el-icon-caret-right'">
        </i>
        <span v-else-if="index === 0" class="ms-tree-space"></span>
        <span v-if="column.text !== '创建时间' && column.text !== '修改时间'">
          <el-tooltip
            v-if="column.text === '团队名称' || column.text === '备注'"
            :content="scope.row[column.dataIndex]"
            placement="top">
            <span>
              {{scope.row[column.dataIndex] && scope.row[column.dataIndex].length > 12
                ? `${scope.row[column.dataIndex].substring(0, 12)}...`
                : scope.row[column.dataIndex]}}
            </span>
          </el-tooltip>
          <span v-else>{{scope.row[column.dataIndex]}}</span>
        </span>
        <span v-else>
          {{scope.row[column.dataIndex] | formatTimeShow}}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="操作" v-if="treeType === 'normal'" align="center" width="280px">
      <template slot-scope="scope">
        <el-button
          @click="handleShowAddMember(scope)"
          type="text"
          size="small"
          v-if="backTeamAuth.teamuser.add.auth">新增成员</el-button>
        <el-button
          @click="handleGoMemberList(scope)"
          type="text"
          size="small"
          v-if="backTeamAuth.teamuser.view.auth">查看成员</el-button>
        <el-button
          @click="handleModifyTeam(scope)"
          type="text"
          size="small"
          v-if="backTeamAuth.update.auth">编辑</el-button>
        <el-button
          @click="handleDeleteTeam(scope)"
          type="text"
          size="small"
          v-if="backTeamAuth.delete.auth">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { formatTimeShow } from '@/scripts/utils';
import { mapGetters } from 'vuex';

export default {
  name: 'tree-grid',
  filters: {
    formatTimeShow,
  },
  props: {
    // 该属性是确认父组件传过来的数据是否已经是树形结构了，如果是，则不需要进行树形格式化
    treeStructure: {
      type: Boolean,
      default: false,
    },
    // 这是相应的字段展示
    columns: {
      type: Array,
      default: [],
    },
    // 这是数据源
    dataSource: {
      type: Array,
      default: [],
    },
    // 这个作用是根据自己需求来的，比如在操作中涉及相关按钮编辑，删除等，需要向服务端发送请求，则可以把url传过来
    requestUrl: {
      type: String,
      default: '',
    },
    // 这个是是否展示操作列
    treeType: {
      type: String,
      default: 'normal',
    },
    // 是否默认展开所有树
    defaultExpandAll: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      backTeamAuth: 'authority/backTeamAuth',
    }),
  },
  methods: {
    // 显示行
    showTr(scope) {
      let showNode = true;
      const checkIsExpanded = (node) => {
        if (node.priParent) {
          if (node.priParent.priExpanded) {
            checkIsExpanded(node.priParent);
          } else {
            showNode = false;
          }
        }
      };
      checkIsExpanded(scope.row);
      return showNode ? '' : 'display:none;';
    },
    // 展开下级
    toggle(trIndex) {
      const record = this.dataSource[trIndex];
      record.priExpanded = !record.priExpanded;
    },
    // 显示层级关系的空格和图标
    spaceIconShow(index) {
      if (this.treeStructure && index === 0) {
        return true;
      }
      return false;
    },
    // 点击展开和关闭的时候，图标的切换
    toggleIconShow(index, record) {
      if (this.treeStructure && index === 0 && record.children) {
        return true;
      }
      return false;
    },
    handleDelete() {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error',
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!',
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    },
    handleShowAddMember(scope) {
      this.$emit('showAddMember', scope);
    },
    handleGoMemberList(scope) {
      this.$emit('goMemberList', scope);
    },
    handleModifyTeam(scope) {
      if (scope.row.id !== 222) {
        this.$emit('modifyTeam', scope);
      }
    },
    handleDeleteTeam(scope) {
      this.$emit('deletTeam', scope);
    },
  },
};
</script>

<style scoped>
.ms-tree-space {
  position: relative;
  top: 1px;
  display: inline-block;
  font-family: "Glyphicons Halflings";
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  width: 10px;
}
.ms-tree-space::before {
  content: "";
}
</style>
